<template>
  <div class="scroll-text" :style="{ color: black ? '#0B243F' : '#999' }">
    <img class="icon" v-if="black" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/text-icon1.png" alt="">
    <img class="icon" v-else-if="white" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/text-icon2.png" alt="">
    <img class="icon" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/text-icon.png" alt="">
		<span :style="{ order: reverse ? -1 : 1, marginRight: reverse ? '6px' : 0 }">{{ $t('newbanner5') }}</span>
  </div>
</template>

<script>
export default {
  name: 'scroll-text',
  props: {
    black: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    },
    reverse: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      
    }
  },
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .scroll-text {
		display: flex;
		align-items: center;
		font-family: Inter, syn;
		font-weight: bold;
		font-size: 16px;
		line-height: 26px;
		text-align: left;
		font-style: normal;

		.icon {
			width: 32px;
			height: auto;
			margin-right: 4px;
		}
	}
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .scroll-text {

  }
}
</style>



// WEBPACK FOOTER //
// src/components/scrollText.vue